import { useState } from 'react'
import { testConnection } from '../utils/testConnection'
import { CheckCircle, XCircle, Loader } from 'lucide-react'

const TestConnection = () => {
  const [testing, setTesting] = useState(false)
  const [result, setResult] = useState(null)

  const handleTest = async () => {
    setTesting(true)
    setResult(null)
    
    const testResult = await testConnection()
    setResult(testResult)
    setTesting(false)
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
      <div className="max-w-2xl w-full bg-white rounded-lg shadow-lg p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">
          Supabase Bağlantı Testi
        </h1>

        <button
          onClick={handleTest}
          disabled={testing}
          className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 flex items-center justify-center space-x-2"
        >
          {testing ? (
            <>
              <Loader className="animate-spin" size={20} />
              <span>Test ediliyor...</span>
            </>
          ) : (
            <span>Bağlantıyı Test Et</span>
          )}
        </button>

        {result && (
          <div className={`mt-6 p-4 rounded-lg ${
            result.success ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'
          }`}>
            <div className="flex items-center space-x-2 mb-2">
              {result.success ? (
                <CheckCircle className="text-green-600" size={24} />
              ) : (
                <XCircle className="text-red-600" size={24} />
              )}
              <h2 className={`text-lg font-semibold ${
                result.success ? 'text-green-800' : 'text-red-800'
              }`}>
                {result.success ? 'Test Başarılı!' : 'Test Başarısız!'}
              </h2>
            </div>

            {result.success ? (
              <div className="text-sm text-green-700 space-y-1">
                <p>✅ Roles tablosu: {result.roles} kayıt</p>
                <p>✅ Users tablosu: {result.users} kayıt</p>
                <p>✅ Login kullanıcısı: {result.loginUser}</p>
              </div>
            ) : (
              <div className="text-sm text-red-700 space-y-2">
                <p><strong>Hata:</strong> {result.error?.message || 'Bilinmeyen hata'}</p>
                {result.error?.code && (
                  <p><strong>Hata Kodu:</strong> {result.error.code}</p>
                )}
                {result.rlsEnabled && (
                  <div className="mt-3 p-3 bg-yellow-50 border border-yellow-200 rounded">
                    <p className="font-semibold text-yellow-800">RLS Aktif!</p>
                    <p className="text-yellow-700 text-xs mt-1">
                      Supabase SQL Editor'da şu komutu çalıştırın:
                    </p>
                    <code className="block mt-2 p-2 bg-yellow-100 rounded text-xs">
                      ALTER TABLE users DISABLE ROW LEVEL SECURITY;
                    </code>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        <div className="mt-6 p-4 bg-gray-50 rounded-lg">
          <h3 className="font-semibold text-gray-900 mb-2">Test Edilenler:</h3>
          <ul className="text-sm text-gray-600 space-y-1">
            <li>• Supabase URL ve Key kontrolü</li>
            <li>• Roles tablosu erişimi</li>
            <li>• Users tablosu erişimi</li>
            <li>• Login kullanıcısı kontrolü</li>
            <li>• RLS durumu kontrolü</li>
          </ul>
        </div>

        <div className="mt-4 text-xs text-gray-500">
          <p>Browser Console'u (F12) açarak detaylı log'ları görebilirsiniz.</p>
        </div>
      </div>
    </div>
  )
}

export default TestConnection


